import { Box } from '@chakra-ui/react';
import React from 'react';
import CreateResume from '../../../components/V2/Dashboard/CreateResume';

const ResumePage = () => {
	return (
		<Box bg={'#F2F6FF'} h="full">
			<CreateResume />
		</Box>
	);
};

export default ResumePage;
